// @ts-nocheck
import { Box, Container, Flex, Image, Link, Text } from "@chakra-ui/react";
import { Button, Input, SwiperContainer } from "components";
import { BsFacebook, BsInstagram, BsLinkedin } from "react-icons/bs";
import { SwiperSlide } from "swiper/react";
import "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";
import { AiFillTwitterCircle } from "react-icons/ai";
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

const SLIDING_TEXTS = [
    'At Ollie you can find the greatest deals and combine the right hotel, transportation and activities. Straight to your fingertips.',
    'Ollie constantly learns from previous bookings, itineraries and reviews so it can improve your travel experience. Before or during your trip. Personalized to you.',
    'Your friends are having the perfect trip, but you have no clue how they managed to put all that together? Do you struggle to find your next inspiring holiday?', 
    'Experience the same trip shared by someone else. In the exact same way. Or… create itineraries and inspire millions. And earn from each user that copies you.'
];

type ILinkedinAccounts = {
    [key: string]: string;
}

const LINKEDIN_ACCOUNTS: ILinkedinAccounts = {
    VALI: 'https://www.linkedin.com/in/valeric-lupoaie/',
    AMATH: 'https://www.linkedin.com/in/amathsow/',
    DAMI: 'https://www.linkedin.com/in/damilolaawe/',
    MARK: 'https://www.linkedin.com/in/mark-pandi-digital-marketing/',
    MARIUS: 'https://www.linkedin.com/in/mariuscapatina/',
    VALENTIN: 'https://www.linkedin.com/in/valentin-manaila/',
    SAKIB: 'https://www.linkedin.com/in/sakibapon/',
    SHEHAN: 'https://www.linkedin.com/in/shehan-abeyrathne-58b262152/',
    ANASTASIYA: 'https://www.linkedin.com/in/voytsekhyvska/',
    ROI: 'https://www.linkedin.com/in/roishahaf/',
    BRUNO: 'https://www.linkedin.com/in/bruno-do-canto-salles-b69553169/'
}

const About = () => {

    const goToLinkeding = (key: string) => {
        window.open(LINKEDIN_ACCOUNTS[key] || '' , '_blank', 'noopener,noreferrer');
    };
    const dataBar = {
        labels: ["May 2022", "June 2022", "July 2022", "Aug 2022", "NOW"],
        datasets: [
          {
            backgroundColor: ['#E9EEF1', '#E9EEF1','#E9EEF1','#E9EEF1', "#3498FE"],
            data: [5, 8, 10, 14, 16, 18]
          }
        ]
      };
  
      const options = {
        scales:{
            y: {
                display: false,
            },
            x: {
                gridLines: {
                    display: false
                }
            }
        },
        plugins: {
          legend: {
            display: false
          }
        },
        
      };
  return (
    <>
        <Container marginTop='7%'>
            <Flex justifyContent='center'>
                <Text fontWeight={700} fontSize='70px'>
                    We are 
                </Text>
                <Text marginLeft='15px' fontWeight={700} fontSize='70px' color='#3498FE'>Ollie</Text>
            </Flex>
            <Flex justifyContent='center' marginBottom='10%'>
                <Text fontWeight={400} fontSize='17px'>Helping you plan your dream vacation at speed of light!</Text>
            </Flex>
            <Image src='../../../phones.png' />
        </Container>
        <Flex paddingLeft='24px' paddingRight='24px'>
            <SwiperContainer>
                <SwiperSlide>
                    <Box backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                        <Text align='center' fontWeight={400} fontSize='17px'>{SLIDING_TEXTS[0]}</Text>
                    </Box>
                </SwiperSlide>
                <SwiperSlide>
                    <Box backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                        <Text align='center' fontWeight={400} fontSize='17px'>{SLIDING_TEXTS[1]}</Text>
                    </Box>
                </SwiperSlide>
                <SwiperSlide>
                    <Box backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                        <Text align='center' fontWeight={400} fontSize='17px'>{SLIDING_TEXTS[2]}</Text>
                    </Box>
                </SwiperSlide>
                <SwiperSlide>
                    <Box backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                        <Text align='center' fontWeight={400} fontSize='17px'>{SLIDING_TEXTS[3]}</Text>
                    </Box>
                </SwiperSlide>
            </SwiperContainer>
        </Flex>
        <Container marginTop='50px'>
            <Flex>
                <Text fontWeight={700} maxWidth='40%' fontSize='55px' marginRight='50px'>Ollie Creators</Text>
                <Container>
                    <SwiperContainer style={{height: '1000px'}} direction="vertical">
                        <SwiperSlide>
                            <Flex flexDirection='column' marginBottom='40px' backgroundColor='#F9F9F9' borderRadius='25px' padding='45px'width='500px'>
                                <Flex align='center'>
                                    <Image src="../../../v_avatar.png" marginRight='30px' />
                                    <Text fontWeight={700} fontSize='22px' marginRight='20px'>Vali Lupoaie</Text>
                                    <BsLinkedin cursor='pointer' color="#3498FE" onClick={() => goToLinkeding('VALI')} />
                                </Flex>
                                <Text align='center' marginTop='20px' fontWeight={400} fontSize='14px'>Serial entrepreneur with background in data science and experience in marketing and sales. Vali is leading Ollie from a multidisciplinary point of view, putting together a team of 14 people on key positions such as software development, artificial intelligence, design, marketing and business.</Text>
                            </Flex>
                        </SwiperSlide>
                        <SwiperSlide style={{marginBottom: '50px'}}>
                            <Flex flexDirection='column' backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                                <Flex align='center'>
                                    <Image height='100px' src="../../../m_avatar.png" marginRight='30px' />
                                    <Text fontWeight={700} fontSize='22px' marginRight='20px'>Mark Pandi</Text>
                                    <BsLinkedin cursor='pointer' color="#3498FE" onClick={() => goToLinkeding('MARK')} />
                                </Flex>
                                <Text align='center' marginTop='20px' fontWeight={400} fontSize='14px'>Entrepreneurial mind and marketing agency owner. Mark is responsible for the correct planning and implementation of the entire marketing department. Outside-the-box thinker, Mark is always looking for different ways of transmitting the message of Ollie through the right marketing.</Text>
                            </Flex>
                        </SwiperSlide>
                        <SwiperSlide style={{marginBottom: '50px'}}>
                            <Flex flexDirection='column' backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                                <Flex align='center'>
                                    <Image borderRadius='100px' height='100px' src="../../../mar_avatar.png" marginRight='30px' />
                                    <Text fontWeight={700} fontSize='22px' marginRight='20px'>Marius Capatina</Text>
                                    <BsLinkedin cursor='pointer' color="#3498FE" onClick={() => goToLinkeding('MARIUS')} />
                                </Flex>
                                <Text align='center' marginTop='20px' fontWeight={400} fontSize='14px'>Real inspiration for the software developers out there. Marius acts like a professional from day 1 at Ollie. Planning the tasks in the front-end development, establishing implementation policies and supporting his colleagues in reaching goals.</Text>
                            </Flex>
                        </SwiperSlide>
                        <SwiperSlide style={{marginBottom: '50px'}}>
                            <Flex flexDirection='column' backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                                <Flex align='center'>
                                    <Image borderRadius='100px' height='100px'  src="../../../d_avatar.png" marginRight='30px' />
                                    <Text fontWeight={700} fontSize='22px' marginRight='20px'>Diana Susanu</Text>
                                </Flex>
                                <Text align='center' marginTop='20px' fontWeight={400} fontSize='14px'>Performer at the highest level of proficiency. With many years of experience in front-end development on international projects, Diana is a vital creator of Ollie. Applying the latest frameworks and trends, she makes Ollie feel as real and responsible as an app can be.</Text>
                            </Flex>
                        </SwiperSlide>
                        <SwiperSlide style={{marginBottom: '50px'}}>
                            <Flex flexDirection='column' backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                                <Flex align='center'>
                                    <Image height='100px'  src="../../../dami_avatar.png" marginRight='30px' />
                                    <Text fontWeight={700} fontSize='22px' marginRight='20px'>Damilola Awe</Text>
                                    <BsLinkedin cursor='pointer' color="#3498FE" onClick={() => goToLinkeding('DAMI')} />
                                </Flex>
                                <Text align='center' marginTop='20px' fontWeight={400} fontSize='14px'>Back-end development runs through his blood. Dami brings his vast experience to build the entire architecture of our application. Micro-service architecture is the way to go in Dami’s eyes. Ready to scale and to grow, to the real potential of Ollie.</Text>
                            </Flex>
                        </SwiperSlide>
                        <SwiperSlide style={{marginBottom: '50px'}}>
                            <Flex flexDirection='column'  backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                                <Flex align='center'>
                                    <Image height='100px'  src="../../../a_avatar.png" marginRight='30px' />
                                    <Text fontWeight={700} fontSize='22px' marginRight='20px'>Amath Sow</Text>
                                    <BsLinkedin cursor='pointer' color="#3498FE" onClick={() => goToLinkeding('AMATH')} />
                                </Flex>
                                <Text align='center' marginTop='20px' fontWeight={400} fontSize='14px'>Determined to enrich peoples destinies through AI. No matter which crazy functionality Ollie should have, Amath finds a way to implement it through the right algorithm. Humble, but with strong arguments, he stands for pioneering AI from the core of Ollie.</Text>
                            </Flex>
                        </SwiperSlide>
                        <SwiperSlide>
                            <Flex flexDirection='column' backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                                <Flex align='center'>
                                    <Image height='100px'  src="../../../val_avatar.png" marginRight='30px' />
                                    <Text fontWeight={700} fontSize='22px' marginRight='20px'>Valentin Manaila</Text>
                                    <BsLinkedin cursor='pointer' color="#3498FE" onClick={() => goToLinkeding('VALENTIN')} />
                                </Flex>
                                <Text align='center' marginTop='20px' fontWeight={400} fontSize='14px'>Taking on challenges as the normal thing. Recently transitioning from architecture to web development, Valentin is the one making sure that we have the perfect website to represent our project. Later, he will expand his knowledge in app development by helping our developer team create Ollie.</Text>
                            </Flex>
                        </SwiperSlide>
                        <SwiperSlide style={{marginBottom: '50px'}}>
                            <Flex flexDirection='column'  backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                                <Flex align='center'>
                                    <Image borderRadius='100px' height='100px'  src="../../../sakib_avatar.png" marginRight='30px' />
                                    <Text fontWeight={700} fontSize='22px' marginRight='20px'>Sakib Apon</Text>
                                    <BsLinkedin cursor='pointer' color="#3498FE" onClick={() => goToLinkeding('SAKIB')} />
                                </Flex>
                                <Text align='center' marginTop='20px' fontWeight={400} fontSize='14px'>Vibrant personality with a passion for data and order. Sakib brings his machine learning experience to support Ollie’s AI functionality, creating the smartest recommendation system on the planet. Together with the team, he makes sure that our models are predicting and anticipating the user's next move.</Text>
                            </Flex>
                        </SwiperSlide>
                        <SwiperSlide style={{marginBottom: '50px'}}>
                            <Flex flexDirection='column'  backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                                <Flex align='center'>
                                    <Image height='100px'  src="../../../shehan_avatar.png" marginRight='30px' />
                                    <Text fontWeight={700} fontSize='22px' marginRight='20px'>Shehan Abeyrathne</Text>
                                    <BsLinkedin cursor='pointer' color="#3498FE" onClick={() => goToLinkeding('SHEHAN')} />
                                </Flex>
                                <Text align='center' marginTop='20px' fontWeight={400} fontSize='14px'>A real warrior with a great purpose. Shehan sustains the front-end development of Ollie in a committed way. With the help of his colleagues, he applies a developmental hybrid approach, so that later on can take the lead of the iOS development.</Text>
                            </Flex>
                        </SwiperSlide>
                        <SwiperSlide style={{marginBottom: '50px'}}>
                            <Flex flexDirection='column'  backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                                <Flex align='center'>
                                    <Image height='100px'  src="../../../anastasiya_avatar.png" marginRight='30px' />
                                    <Text fontWeight={700} fontSize='22px' marginRight='20px'>Anastasiya Voytsekhivska</Text>
                                    <BsLinkedin cursor='pointer' color="#3498FE" onClick={() => goToLinkeding('ANASTASIYA')} />
                                </Flex>
                                <Text align='center' marginTop='20px' fontWeight={400} fontSize='14px'>Sensitive visionary able to sketch the future. With an incredible eye for design, Anastasiya is shaping Ollie from the very beginning. Making sure that the latest trends are applied in design and user experience, she is setting the direction of our app.</Text>
                            </Flex>
                        </SwiperSlide>
                        <SwiperSlide style={{marginBottom: '50px'}}>
                            <Flex flexDirection='column'  backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                                <Flex align='center'>
                                    <Image height='100px'  src="../../../bruno_avatar.png" marginRight='30px' />
                                    <Text fontWeight={700} fontSize='22px' marginRight='20px'>Bruno Salles</Text>
                                    <BsLinkedin cursor='pointer' color="#3498FE" onClick={() => goToLinkeding('BRUNO')} />
                                </Flex>
                                <Text align='center' marginTop='20px' fontWeight={400} fontSize='14px'>Pure soul with the intention to make the world a better place. Bruno is joining the business development department, having great entrepreneurial experience and powerful connections in Portugal. He brings innovation, creativity and outside the box thinking to help us grow our company.</Text>
                            </Flex>
                        </SwiperSlide>
                        <SwiperSlide style={{marginBottom: '50px'}}>
                            <Flex flexDirection='column'  backgroundColor='#F9F9F9' borderRadius='25px' padding='45px' width='500px'>
                                <Flex align='center'>
                                    <Image height='100px'  src="../../../roi_avatar.png" marginRight='30px' />
                                    <Text fontWeight={700} fontSize='22px' marginRight='20px'>Roi Shahaf</Text>
                                    <BsLinkedin cursor='pointer' color="#3498FE" onClick={() => goToLinkeding('ROI')} />
                                </Flex>
                                <Text align='center' marginTop='20px' fontWeight={400} fontSize='14px'>The wise business expert who gets what he wants Roi brings his marketing and sales experience to support the growth of Ollie. From crowd-funding campaigns to outside the box strategies, he will make sure that we reach our realistic goals.</Text>
                            </Flex>
                        </SwiperSlide>
                    </SwiperContainer>
                </Container>
            </Flex>
        </Container>
        <Flex marginRight='20%' marginLeft='20%' align='center'>
            <Flex flexDirection='column' width='50%'>
                <Text  marginBottom='20px' fontWeight={700} fontSize='55px'>This is how <Text display='inline' color='#3498FE'>Ollie</Text> is doing</Text>
                <Text fontWeight={400} fontSize='17px'>Ollie started in 2022 with commitment to provide a seemless and all-in-one quick processing of your trips.  Yes, we’re shooting for the moon but we’re doing it responsibly and using our substantial investment capital wisely. See for yourself. This chart of employee size will give a clear sense of where we’re headed and what — or rather who — we believe in. </Text>
            </Flex>
            <Container>
                <Bar data={dataBar} options={options} width={100} height={50} />
            </Container>
        </Flex>
        <Flex backgroundColor='#3498FE' marginTop='20px' flexDirection='column' align='center' padding='100px'>
            <Text color='#FEFEFE' fontWeight={700} fontSize='55px'>Our culture</Text>
            <Text color='#FEFEFE' fontWeight={400} marginBottom="50px" width="35%" textAlign='center' fontSize='17px'>At Ollie, passion is necessary, talent is nurtured and opportunities are given. Going above-and-beyond the standard is expected and successes are celebrated.</Text>
            <Flex paddingLeft='30px' paddingRight='30px' backgroundColor='rgba(255, 255, 255, 0.3)' borderRadius='25px'>
                <Button label='Join Us' onClick={() => window.open('https://ollieapp.travel/', '_blank', 'noopener,noreferrer')} colorScheme='white' /> 
            </Flex>
        </Flex>
        <Container marginTop='20%' marginBottom='10%'>
            <Flex align='center' flexDirection='column'>
                <Text fontWeight={700} fontSize='55px'>Our Partners</Text>
            </Flex>
        </Container>
        <Flex justifyContent='space-between' marginLeft='20%' marginRight='20%'>
            <Box width='300px' borderRadius='25px' backgroundColor='#F9F9F9' padding='45px'>
                <Image src="../../../protea.png"/>
            </Box>
            <Box width='300px' borderRadius='25px' backgroundColor='#F9F9F9' padding='60px' paddingTop='100px'>
                <Image src="../../../radisson.png" />
            </Box>
            <Box width='300px'  borderRadius='25px' backgroundColor='#F9F9F9' padding='45px'>
                <Image src="../../../ac_hotels.png"/>
            </Box>
        </Flex>
        <Flex marginTop='20px' justifyContent='space-between' align='center' marginLeft='20%' marginRight='20%'>
            <Box width='300px' borderRadius='25px' backgroundColor='#F9F9F9' padding='45px'>
                <Image src="../../../marriot.png"/>
            </Box>
            <Box width='300px' borderRadius='25px' backgroundColor='#F9F9F9' padding='45px'>
                <Image src="../../../hilton.png"/>
            </Box>
            <Box width='300px' borderRadius='25px' backgroundColor='#F9F9F9' padding='45px'>
                <Image src="../../../sheraton.png"/>
            </Box>
        </Flex>
        <Container size='xl' marginTop='10%' marginBottom='10%'>
            <Flex align='center' flexDirection='column'>
                <Text fontWeight={700} fontSize='55px'>Core Values</Text>
                <Text textAlign='center' fontWeight={400} fontSize='17px'>Our founding principles are at the core of our culture and guide every decision we make.</Text>
            </Flex>
        </Container>
        <Flex align='end' justifyContent='space-between'  marginLeft='20%' width='60%'>
            <Box borderRadius='25px' backgroundColor='#006EDE' padding='100px'>
                <Text color='#FEFEFE' fontWeight={700} fontSize='26px' >Teamwork</Text>
            </Box>
            <Box borderRadius='25px'  backgroundColor='#3498FE' padding='100px' paddingTop='250px'>
                <Text color='#FEFEFE' fontWeight={700} fontSize='26px'>Sustainability</Text>
            </Box>
            <Box borderRadius='25px' backgroundColor='#006EDE' padding='100px'>
                <Text color='#FEFEFE' fontWeight={700} fontSize='26px'>Ownership</Text>
            </Box>
        </Flex>
        <Flex backgroundColor='#3498FE' marginTop='20px'  align='center' padding='100px' borderTopEndRadius='25px' paddingBottom='10%' borderTopStartRadius='25px'>
            <Container maxWidth='80%' verticalAlign='center'>
                <Flex justifyContent='space-between'>
                    <Flex flexDirection='column' align='start' width='25%'>
                        <Text color='#FEFEFE' fontWeight={700} fontSize='22px' marginBottom='20px'>Landing map</Text>
                        <Link color="#FEFEFE" fontWeight={400} fontSize='14px'> About</Link>
                        <Link color="#FEFEFE" fontWeight={400} fontSize='14px'>Partners</Link>
                        <Link color="#FEFEFE" fontWeight={400} fontSize='14px'>Team</Link>
                    </Flex>
                    <Flex flexDirection='column' align='center' width='600px' marginRight='20%'>
                        <Text color='#FEFEFE' fontWeight={700} fontSize='22px' marginBottom='20px'>Newsletter</Text>
                        <Input placeholder='Enter your email' padding={5} />
                        <Flex marginTop='20px'></Flex>
                        <Button size='lg' label='Subscribe' onClick={function (): void {
                              throw new Error("Function not implemented.");
                          } } variant="outline" colorScheme='whiteAlpha' />
                    </Flex>
                    <Flex flexDirection='column' align='start'>
                        <Text color='#FEFEFE' fontWeight={700} fontSize='22px' marginBottom='20px'>Contact</Text>
                        <Text color="#FEFEFE" fontWeight={400} fontSize='14px'>Bucharest, RO</Text>
                        <Link color="#FEFEFE" fontWeight={400} fontSize='14px' href="mailto:info@ollieapp.com">info@ollieapp.com</Link>
                        <Flex marginTop='20px' width='100px' justifyContent='space-between'>
                            <BsLinkedin cursor='pointer' color="white" />
                            <BsFacebook cursor='pointer' color="white" />
                            <BsInstagram cursor='pointer' color="white" />
                            <AiFillTwitterCircle cursor='pointer' color="white" />
                        </Flex>
                    </Flex>
                </Flex>
            </Container>
        </Flex>
    </>
  );
};

export { About };
